import { jsxs as e, jsx as t } from "react/jsx-runtime";
import { forwardRef as c } from "react";
import i from "../../../../node_modules/@faststore/components/dist/esm/molecules/IconButton/IconButton.js";
const p = c(function({
  quantity: n,
  testId: l = "store-quantity-selector",
  leftButtonProps: r,
  rightButtonProps: o,
  measureUnit: a,
  ...s
}, u) {
  return /* @__PURE__ */ e(
    "div",
    {
      className: "quantity-selector",
      "data-testid": l,
      ref: u,
      ...s,
      children: [
        /* @__PURE__ */ t(
          i,
          {
            "aria-controls": "quantity-selector-input",
            "aria-label": "Diminuir quantidade",
            className: "quantity-selector-button button-plus",
            ...r
          }
        ),
        /* @__PURE__ */ e("div", { style: { display: "flex", alignItems: "center" }, children: [
          /* @__PURE__ */ t("div", { style: { width: "auto" }, children: /* @__PURE__ */ t("p", { "aria-label": "Quantidade", className: "quantity-selector-quantity", children: n }) }),
          a && a !== "un" && /* @__PURE__ */ t("p", { className: "quantity-selector-measure-unit", children: a })
        ] }),
        /* @__PURE__ */ t(
          i,
          {
            "aria-controls": "quantity-selector-input",
            "aria-label": "Aumentar quantidade",
            className: "quantity-selector-button quantity-selector-button-plus",
            ...o
          }
        )
      ]
    }
  );
});
export {
  p as default
};
